module.exports = __webpack_public_path__ + "static/media/details-3.7345b9f6.jpeg";


//////////////////
// WEBPACK FOOTER
// ./src/images/details-3.jpeg
// module id = 71
// module chunks = 0